// extracted by mini-css-extract-plugin
module.exports = {"container":"Submitted_container__3FlwL","title":"Submitted_title__3XrtU","description":"Submitted_description__1F3K2"};